import Cookies from "js-cookie";

const COOKIE_NAME = "__authentigate_t1_checkout_email";
const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const isValidEmail = (email: string): boolean =>
    EMAIL_REGEX.test(email.trim());

export const getSavedCheckoutEmail = (): string | undefined =>
    Cookies.get(COOKIE_NAME);

export const saveCheckoutEmail = (email: string): void => {
    const trimmed = email.trim();
    if (!isValidEmail(trimmed)) return;
    Cookies.set(COOKIE_NAME, trimmed, {
        expires: 365,
        secure: true,
        sameSite: "lax",
    });
};
